import axios from "axios";
const server = axios.create({
  baseURL: "https://gwt.giantweather.com:18088/cms/",
  timeout: 50000
});
export default server;
